module.exports = __webpack_public_path__ + "dingbeauty-landing/img/menu-bar.8f563664.svg";